<div class="h-screen w-screen flex overflow-hidden bg-gray-50">
    <app-admin-sidebar class="hidden md:flex flex-shrink-0 h-full shadow-sm z-30"></app-admin-sidebar>

    <div class="flex-1 flex flex-col min-w-0 overflow-hidden">
        <app-admin-header></app-admin-header>

        <main class="flex-1 overflow-y-auto p-4 md:p-8 scroll-smooth">
            <div class="w-full mx-auto space-y-6 fade-in pb-10">
                <router-outlet></router-outlet>
            </div>
        </main>
    </div>

    <app-help-fab />
    <app-shift-handover-gate />
</div>